import styled from 'styled-components';

import ImageSlider from 'components/ImageSlider';

import COLORS from 'styles/colors';
import BREAKPOINTS from 'styles/breakpoints';
import { H3 } from 'styles/typography';

const Section = styled.section`
  background: ${COLORS.redWine};
  padding: 110px 0;

  ${BREAKPOINTS.small`
    padding: 100px 0;
  `}
`;

const SectionHeading = styled(H3)`
  margin-bottom: 60px;
  text-align: center;
  color: ${COLORS.lilac};
`;

const Slider = styled(ImageSlider)`
  .slick-dots {
    position: static;
    margin-top: 20px;

    li button::before {
      background-color: ${COLORS.pinkMillennial.opacity(0.2)};
    }

    li.slick-active button::before {
      background-color: ${COLORS.lilac};
    }
  }
`;

const sliderSettings = {
  slidesToShow: 1,
  autoplay: false,
  dots: true,
  speed: 1500,
};

const ImageCarousel = ({ images, title, className }) => {
  return (
    <Section className={className}>
      <SectionHeading weight="bold">{title}</SectionHeading>
      <Slider
        images={images}
        customSettings={sliderSettings}
        imageSize="landscape"
      />
    </Section>
  );
};

export default ImageCarousel;
